import { render } from "./index.vue?vue&type=template&id=d97f77ba"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=d97f77ba&lang=less"
script.render = render

export default script